import Icon from "../../../components/Icon";
import Colors from "../../../constants/Colors";

const MoreOptionsButton = ({ onPress }) => (
  <Icon
    name="more-horizontal"
    size={24}
    color={Colors.primary_500}
    onPress={onPress}
  />
);

export default MoreOptionsButton;
